<template>
  <div style="height: 600px; width: 100%;">
    <l-map
      v-if="showMap"
      :zoom="zoom"
      :center="center"
      :bounds="latLngData"
      :padding="[10, 10, 10, 10]"
      :options="mapOptions"
      style="height: 80%; z-index: 0;"
    >
      <!-- @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
      @update:bounds="boundsUpdated" -->
      <l-tile-layer :url="url" :attribution="attribution"/>
      <l-control-layers style="text-align: left;"  position="topright"  ></l-control-layers>
      <l-tile-layer style="text-align: left;"
        v-for="tileProvider in tileProviders"
        :key="tileProvider.name"
        :name="tileProvider.name"
        :visible="tileProvider.visible"
        :url="tileProvider.url"
        :attribution="tileProvider.attribution"
        layer-type="base"/>

      <l-control-scale position="bottomright" :imperial="true" :metric="false"></l-control-scale>
      <l-marker :lat-lng="[marker[0], marker[1]]" v-for="(marker, index) in mapData" :key="`marker-${index}`">
      </l-marker>
    </l-map>
    <p v-if="markerCount > 0">Samples collected from {{ markerCount }} site<span v-if="markerCount > 1">s</span>.</p>
    <div style="height: 200px; text-align: left; overflow: auto;" v-if="!allArrayItemsNull(dateArray)">
    </div>
  </div>
</template>

<script>
import { latLngBounds, latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LControlScale, LControlLayers } from "vue2-leaflet";

export default {
  name: "VDMap",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LControlScale,
    LControlLayers,
  },
  props: {
    mapData: Array,
  },
  data() {
    return {
      zoom: 6,
      center: latLng(this.mapData[0][0], this.mapData[0][1]),
      latLngData: [],
      bounds: latLngBounds(this.latLngData),
      dateArray: [],
      
      tileProviders: [
        {
          name: 'Street',
          visible: true,
          url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
          attribution:
            'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012',
        },
        {
          name: 'Terrain',
          visible: false,
          url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/terrain/{z}/{x}/{y}{r}.png',
          attribution:
            'Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        },
        {
          name: 'Satellite ',
          visible: false,
          url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
          attribution:
            'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
        },
        // {
        //   name: 'Light',
        //   visible: false,
        //   url: 'http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png',
        //   attribution:
        //     '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        // },
        {
          name: 'Dark',
          visible: false,
          url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}{r}.png',
          attribution:
            '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>',
        },
        {
          name: 'OpenStreetMap',
          visible: false,
          url: "http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
          attribution:
            '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors ' +
              '<a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
              'Imagery © <a href="http://mapbox.com">Mapbox</a>'
        },
      ],

      url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
      attribution:
        'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012',
      currentZoom: 6,
      currentCenter: latLng(this.lat, this.long),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        maxZoom: 17,
      },
      showMap: true,
    };
  },
  computed: {
    markerCount: function () {
      return this.mapData.length;
    },
  },
  methods: {
    // zoomUpdate(zoom) {
    //   this.currentZoom = zoom;
    // },
    // centerUpdate(center) {
    //   this.currentCenter = center;
    // },
    // boundsUpdated (bounds) {
    //   this.bounds = bounds;
    // },
    extractLatLngData() {
      if (this.mapData.length > 1){
        const latLngArray = [];

        this.mapData.forEach(function(arr) {
          const location = [];
          location[0] = arr[0];
          location[1] = arr[1];
          latLngArray.push(location);
        });

        this.latLngData = latLngArray;
      }
      else {
        this.latLngData = null;
      }
      
    },
    allArrayItemsNull: function(arr) {
      return arr.every(val => val === undefined || val === null);
    },
  },
  created: function() {
    this.extractLatLngData();
  },
};
</script>
